<template>
    <Button
        :type="isNotEmpty ? 'primary' : 'default'"
        :ghost="isNotEmpty"
        @click="onClick"
    >
        <span class="adv-text">筛选</span>
        <common-icon
            class="adv-icon"
            type="ios-funnel"
            :size="14"
            :color="isNotEmpty ? $theme.primaryColor : 'black'"
        ></common-icon>
        <smart-modal
            v-model="show"
            :width="800"
            :height="600"
            :maskClosable="false"
            :showHeader="false"
            :modalBeforeEnter="fetch"
            :modalBeforeBtnClick="btnHandlers"
            :buttons="buttons"
            @close-by-confirm="onConfirm"
        >
            <Form
                class="adv-form"
                ref="pInfo"
                :model="pInfo"
                :rules="rules"
                :label-width="200"
                label-position="top"
            >
                <FormItem label="房源编号" prop="houseName">
                    <Input
                        v-model="pInfo.houseName"
                        placeholder="请输入房源编号"
                        style="display: inline-block; width: 220px"
                    ></Input>
                    <span style="margin-left: 30px"
                        >房源编号规则：楼栋英文-楼层-房号。如C83,9621,BB523</span
                    >
                </FormItem>
                <FormItem label="费用类型" prop="feeType">
                    <check-tag-group
                        v-model="pInfo.feeType"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in this.dict.feeType.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem
                    v-if="payLabel.length"
                    :label="payLabel"
                    prop="payType"
                >
                    <check-tag-group
                        v-model="pInfo.payType"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in this.dict.payType.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem
                    v-if="name === 'billDs'"
                    label="待收状态"
                    prop="dsStatus"
                >
                    <check-tag-group
                        v-model="pInfo.dsStatus"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in this.dsStatusList"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem
                    v-if="name === 'billYs'"
                    label="收据状态"
                    prop="receiptStatus"
                >
                    <check-tag-group
                        v-model="pInfo.receiptStatus"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in this.dict.receiptStatus.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem
                    v-if="name === 'billDf'"
                    label="待付状态"
                    prop="dfStatus"
                >
                    <check-tag-group
                        v-model="pInfo.dfStatus"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in this.dfStatusList"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem label="（收款/付款/作废）操作人" prop="updateUser">
                    <check-tag-group
                        v-model="pInfo.updateUser"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in updateUserList"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.nickname }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem label="日期" prop="remark">
                    <div>
                        <div class="flex">
                            <check-tag-group
                                v-model="includeTime"
                                color="primary"
                                multiple
                                @on-change="onTimeChange"
                                ><check-tag
                                    class="adv-check-tag"
                                    name="createTime"
                                    >{{ timeLabel }}</check-tag
                                >
                            </check-tag-group>
                            <filter-date-range
                                v-show="includeTime.length"
                                :startDate.sync="pInfo.startDate"
                                :endDate.sync="pInfo.endDate"
                            ></filter-date-range>
                        </div>
                    </div>
                </FormItem>
            </Form>
        </smart-modal>
    </Button>
</template>

<script>
import FilterDateRange from '_vc/filter/filter-date-range'
import { usersByOrg } from '@/api/sys-org'
import { type } from '_u/helper'

export default {
    name: 'BillAdvSearch',
    components: {
        FilterDateRange,
    },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        name: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            show: false,
            buttons: [
                { type: 'default', text: '重置', name: 'reset' },
                { type: 'primary', text: '确定', name: 'confirm' },
            ],
            btnHandlers: {
                reset: this.onReset,
            },
            dict: {
                billStatus: this.$dict.NULL,
                receiptStatus: this.$dict.NULL,
                feeType: this.$dict.NULL,
                payType: this.$dict.NULL,
            },
            pInfo: {
                houseName: '',
                feeType: [],
                payType: [],
                dsStatus: [],
                dfStatus: [],
                receiptStatus: [],
                updateUser: [],
                startDate: '',
                endDate: '',
            },
            updateUserList: [],
            includeTime: [],
        }
    },
    computed: {
        rules() {},
        isNotEmpty() {
            return Object.values(this.value).some((v) => v.length)
        },
        // 待收状态-应收、未收、待确认
        dsStatusList() {
            return this.dict.billStatus.toList().filter((v) => {
                const remark = JSON.parse(v.remark)
                return remark.type === 'ds'
            })
        },
        // 待付状态-应付、未付
        dfStatusList() {
            return this.dict.billStatus.toList().filter((v) => {
                const remark = JSON.parse(v.remark)
                return remark.type === 'df'
            })
        },
        //
        payLabel() {
            if (this.name === 'billYs') return '收款方式'
            if (this.name === 'billYf') return '付款方式'
            return ''
        },
        // 日期筛选标题
        timeLabel() {
            if (this.name === 'billDs') return '应收款日'
            if (this.name === 'billYs') return '已收款时间'
            if (this.name === 'billDf') return '应付款日'
            if (this.name === 'billYf') return '已付款时间'
            if (this.name === 'billZf') return '作废日'
            return ''
        },
    },
    methods: {
        fetch(next) {
            return Promise.all([
                this.$dict.get([
                    'bill_status',
                    'receipt_status',
                    'fee_type',
                    'pay_type',
                ]),
                usersByOrg('财务'), // 财务
            ])
                .then((args) => {
                    var [group, user] = args

                    Object.assign(this.dict, group)
                    this.updateUserList = user.data.data
                    // 重新赋值
                    var val = this.value || {}
                    Object.keys(this.pInfo).forEach((k) => {
                        if (typeof val[k] !== 'undefined') {
                            this.pInfo[k] = val[k]
                        }
                    })
                    // 日期
                    this.includeTime =
                        this.pInfo.startDate || this.pInfo.endDate
                            ? ['time']
                            : []
                })
                .then(() => next())
        },
        onClick() {
            this.show = true
        },
        onConfirm() {
            this.$emit('input', this.pInfo)
            this.$emit('confirm', this.pInfo, this.getSelectedOptions())
        },
        onTimeChange(val) {
            if (val.length <= 0) {
                this.pInfo.startDate = ''
                this.pInfo.endDate = ''
            }
        },
        // 重置
        onReset(next, options) {
            options.closeModal = false
            Object.keys(this.pInfo).forEach((k) => {
                this.pInfo[k] = typeof this.pInfo[k] === 'object' ? [] : ''
            })
            next()
        },
        getSelectedOptions() {
            var options = []

            Object.keys(this.pInfo).forEach((k) => {
                var v = this.pInfo[k]

                // 日期区间
                // prettier-ignore
                if (k === 'startDate') {
                    var t1 = k,
                        t2 = 'endDate',
                        v1 = this.pInfo[t1],
                        v2 = this.pInfo[t2],
                        title = this.timeLabel

                    if(!v1 && !v2){
                        return
                    }

                    options.push({
                        id: `${v1}-${v2}`,
                        key: `${t1}-${t2}`,
                        text: `${v || '不限'}至${this.pInfo[t2] || '不限'}`,
                        label: `${title}`
                    })
                } else if (v) {
                    // prettier-ignore
                    switch (k) {
                        case 'houseName':
                            options.push({
                                id: v,
                                text: `${v}`,
                                key: k,
                                label: '房间编号'
                            })
                            break
                        case 'feeType':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.dict.feeType.val(p),
                                key: k,
                                label: '费用类型'
                            }))
                            break
                        case 'payType':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.dict.payType.val(p),
                                key: k,
                                label: this.payLabel
                            }))
                            break
                        case 'dsStatus':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.dict.billStatus.val(p),
                                key: k,
                                label: '待收状态'
                            }))
                            break
                        case 'dfStatus':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.dict.billStatus.val(p),
                                key: k,
                                label: '待付状态'
                            }))
                            break
                        case 'receiptStatus':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.dict.receiptStatus.val(p),
                                key: k,
                                label: '收据状态'
                            }))
                            break
                        case 'updateUser':
                            v.forEach(p => {
                                var user = this.updateUserList.find(s => s.id === p)

                                if(user){
                                    options.push({
                                        id: p,
                                        text: user.nickname,
                                        key: k,
                                        label: '操作人'
                                    })
                                }
                            })
                            break
                    }
                }
            })

            return options
        },
    },
}
</script>

<style lang="less" scoped>
.adv {
    &-form {
        padding: 0 10px;
    }
    &-text {
        margin-right: 10px;
    }
    &-icon {
        vertical-align: -1px;
    }
    &-check-tag {
        padding: 2px 12px;
        height: auto;
    }
}
</style>
